<template>
  <router-view :key="$route.fullPath" />
  <Toasts />
  <CollabStatusBanner />
  <div class="mt-3 pb-5" />
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue';
import Toasts from '@app/components/generic/toasts.vue';
import CollabStatusBanner from '@app/components/generic/collabStatusBanner.vue';
import store from '@app/store';

let beforeUnloadHandler: null | ((event: BeforeUnloadEvent) => void) = null;

onMounted(() => {
  beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    const hasUnsynced = Object.values(store.state.collabConnections)
      .some((entry) => entry.hasUnsyncedChanges);
    if (hasUnsynced) {
      event.preventDefault();
      // Required for some browsers (Chrome) to actually show the prompt.
      event.returnValue = '';
    }
  };
  window.addEventListener('beforeunload', beforeUnloadHandler);
});

onBeforeUnmount(() => {
  if (beforeUnloadHandler) {
    window.removeEventListener('beforeunload', beforeUnloadHandler);
    beforeUnloadHandler = null;
  }
});
</script>
